import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueI18n from 'vue-i18n';
import messages from "./languages/index";

Vue.use(VueI18n);
Vue.config.productionTip = false;

const i18n = new VueI18n({
  locale: 'de',
  messages
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  i18n,
}).$mount("#app");
